import React, { useState } from 'react';
import EventBanner from '../components/EVENTBANNER/EventBanner';
import Countdown from "../components/COUNTDOWN/Countdown";
import HeroVideo from "../components/HEROVIDEO/HeroVideo";
import Categories from '../components/CATEGORIES/Categories';
import { FaMedal, FaRegMoneyBillAlt} from "react-icons/fa";
import { RiTeamFill } from "react-icons/ri";
import { MdTimer } from "react-icons/md";
import { GiTrophyCup } from "react-icons/gi";
import { FaMapMarkerAlt, FaClock } from "react-icons/fa";
import ButtonBases from '../components/ButtonBases/ButtonBases';
import Carrusel2 from '../components/CARROUSEL2/Carrousel2';
import Mapping from '../components/MAPPING/Mapping';
import Responsib from '../components/RESPONSIBILITIES/Responsib';
import Modal from '../components/MODAL/Modal';
import emailjs from '@emailjs/browser';
import CulqiButton from '../components/CulqiCheckoutButton/CulqiButton';

export default function TRAIL_DEL_PESCADOR() {

  /*PRIMERA PREVENTA, SEGUNDA PREVENTA, VENTA FINAL*/
  const tipoPreventa="PESCADOR VENTA FINAL";

  const handleFinalResult = async(result) => {
  if (result.success) {
    /*EVITAR QUE PAGUE SIN INTERNET*/
    if (!navigator.onLine) {
      alert("No tienes conexión a internet. Por favor, inténtalo de nuevo cuando tengas conexión");
      return;
    }
    setEnviando(true);
    try {

      console.log("Pago exitoso:", result);

      console.log("ANTES GOOGLE");

      await guardarInscripcionGoogle();

      console.log("DESPUES GOOGLE");

      console.log("ANTES EMAIL");

      await enviarCorreo();

      console.log("DESPUES EMAIL");

    } catch (error) {

      console.log("ERROR REAL:", error);

      alert(
        "ERROR REAL: " +
        error.message
      );
    } finally {
      setEnviando(false);
    }
  } else {
    console.log("Error en el pago");
    alert(
      "El pago no se pudo procesar" +
      (result.error ? ": " + result.error : "")
    );
  }
};

/*Evitar doble clic*/
const [loadingStep, setLoadingStep] = useState(false);

/*RESETEAR FORMULARIO*/
const resetFormulario = () => {
  setGrupo("ALPHA");
  setStep(1);

  setNombre("");
  setApellidos("");
  setDni("");
  setCorreo("");
  setTelefono("");
  setGenero("");
  setFechaNacimiento("");
  setTalla("M");
  setOtroEquipo("");
  setFotoBienvenida(null);

  setBasesGenerales(false);
  setDeslindeResponsabilidad(false);
  setResponsabilidadSensor(false);
  setDatosCorrectos(false);

  setSelectedItem(null);
};

  /*Estado para controlar el grupo seleccionado en el formulario de inscripción */
  const [grupo, setGrupo] = useState("ALPHA");

  /*Estado pasos del formulario de inscripción */
  const [step, setStep] = useState(1);

  /*Datos del formulario de inscripción */
  const [nombre, setNombre] = useState("");
  const [apellidos, setApellidos] = useState("");
  const [dni, setDni] = useState("");
  const [correo, setCorreo] = useState("");
  const [telefono, setTelefono] = useState("");
  const [genero, setGenero] = useState("");
  const [fechaNacimiento, setFechaNacimiento] = useState("");
  const [talla, setTalla] = useState("M");
  const [otroEquipo, setOtroEquipo] = useState("");
  const [fotoBienvenida, setFotoBienvenida] = useState(null);

  /*Estados para controlar los checkbox de términos y condiciones */
  const [bases_generales, setBasesGenerales] = useState(false);
  const [deslinde_responsabilidad, setDeslindeResponsabilidad] = useState(false);
  const [responsabilidad_sensor, setResponsabilidadSensor] = useState(false);
  const[datos_correctos, setDatosCorrectos] = useState(false);

  /* Estado para controlar el modal y el ítem seleccionado */
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  /*Función para enviar correo con los datos del formulario usando EmailJS */
 const enviarCorreo = async () => {
  const templateParams = {
    nombre,
    apellidos,
    dni,
    correo,
    telefono,
    genero,
    fechaNacimiento,
    grupo:
      grupo === "otro"
      ? otroEquipo
      : grupo,

    talla,
  };
  try {
    await emailjs.send(
      "service_gi2cwnf",
      "template_01qt16e",
      templateParams,
      "3ElF522uPVPnXza99"
    );
    alert(nombre+" ,tu inscripción se ha completado exitosamente. ¡Gracias por ser parte de esta gran aventura!\nSe enviará un correo de confirmación a "+correo+" con los detalles de tu inscripción.\nEn el mismo correo está el link para que te puedas unir al grupo de WhatsApp de la carrera. ¡Nos vemos en la carrera!");
    setModalOpen(false);
    resetFormulario();
  } catch (error) {
    console.log(error);
    throw error;
  }
};

  /*Guardar inscripción en google sheet, además de subir foto*/
  const guardarInscripcionGoogle = async () => {

  try {

    let fotoBase64 = "";
    let fotoMimeType = "";

    if (fotoBienvenida) {

      fotoMimeType = fotoBienvenida.type;

      fotoBase64 = await new Promise((resolve, reject) => {

        const reader = new FileReader();

        reader.readAsDataURL(fotoBienvenida);

        reader.onload = () => {

          const base64 = reader.result.split(",")[1];

          resolve(base64);
        };

        reader.onerror = error => reject(error);
      });
    }

    const payload = {
      nombre,
      apellidos,
      dni,
      correo,
      telefono,
      genero,
      fechaNacimiento,

      grupo:
        grupo === "otro"
          ? otroEquipo
          : grupo,

      talla,
      tipoPreventa,
      fotoBase64,
      fotoMimeType
    };

    const response = await fetch(
      "https://script.google.com/macros/s/AKfycbx9m94caF6b9Bhw3ttQ396HpMNcYKqQCLT3VCSKj5YVRPiSN_wZL_AF-QMQb1foCGul/exec",
      {
        method: "POST",
        body: JSON.stringify(payload)
      }
    );

    // 👇 AQUÍ VA
    const text = await response.text();

    console.log("RESPUESTA CRUDA:", text);

    const result = JSON.parse(text);

    console.log("Google Sheets:", result);

    if (!result.success) {
      throw new Error(result.error || "Error al guardar en Google Sheets");
    }

  } catch (error) {

    console.log("Error Google Sheets:", error);

    throw error;
  }
};

  /*Estado de carga de envío de correo*/
  const [enviando, setEnviando] = useState(false);

  /*Items de tipo de inscripción*/
  const items_inscripcion = [
    {
        img: "https://atacaperu.com/wp-content/uploads/2026/05/667365336_122121142869170678_2140071024310354874_n.avif",
        title: "¡Inscríbite ahora!",
        desc: "¡Corre donde el mar y la arena desafían tus límites! Prepárate para vivir una experiencia única entre el mar, la arena y la fuerza del norte. \nPrecio venta final: S/.120.00 (hasta el domingo 21 de junio)",
        btnText: "Inscribirme",
    }
  ]

  /*Función para abrir el modal con el ítem seleccionado */
  const abrirModal = (item) => {
      setSelectedItem(item);
      setStep(1); // Reiniciar al paso 1 cada vez que se abre el modal
      setModalOpen(true);
  };

  const items_responsib = [
  {
      img: "https://atacaperu.com/wp-content/uploads/2026/05/2.avif",
      title: "Deslinde de Responsabilidad",
      desc: "Aceptación de riesgos y condiciones del evento.",
      link: "https://atacaperu.com/wp-content/uploads/2026/05/DESLINDE-TRAIL-DEL-PESCADOR.pdf",
      btnText: "Ver documento",
    },

    {
      img: "https://atacaperu.com/wp-content/uploads/2026/05/3.avif",
      title: "Dispositivo Sensor",
      desc: "Uso correcto y responsabilidad del equipo.",
      link: "https://atacaperu.com/wp-content/uploads/2025/02/RESPONSABILIDAD-SENSOR.pdf",
      btnText: "Ver documento",
    },

    {
      img: "https://atacaperu.com/wp-content/uploads/2026/05/1.avif",
      title: "Autorización de Menor",
      desc: "Permiso para participación de menores.",
      link: "https://atacaperu.com/wp-content/uploads/2026/05/AUTORIZACION-TRAIL-DEL-PESCADOR-MENORES.pdf",
      btnText: "Ver documento",
    },
  ];

  /*Carrusel 2 imagenes*/
  const images_carrousel2=[
      "https://atacaperu.com/wp-content/uploads/2026/05/701313432_1828615631879010_3829468554739370638_n.avif",
      "https://atacaperu.com/wp-content/uploads/2026/05/700208264_1827702155303691_1205507908146195870_n.avif",
      "https://atacaperu.com/wp-content/uploads/2026/05/697177072_1826755695398337_2843395840613015311_n.avif",
  ]

  /*Detalles del hero section*/
  const detalles_hero = [
      { icon: <FaMapMarkerAlt />, label: "Lugar", value: "Playa los Órganos, Piura, Perú" },
      { icon: <FaClock />, label: "Hora", value: "08:00 AM" },
      { icon: <FaMedal />, label: "Premios", value: "Reconocimientos a ganadores" },
  ];

  const categorias = [
      "Damas y Varones Juveniles: de 15 a 17 años",
      "Damas y Varones Elite: de 18 a 34 años",
      "Damas y Varones Máster: de 35 a 49 años",
      "Damas y Varones Súper Máster: de 50 años a más"
  ];

  const detalles = [
    { label: "Fecha", value: "29 de marzo 2026" },
    { label: "Lugar", value: "Playa los Órganos, Piura, Perú" },
    { label: "Concentración", value: "07:30 AM" },
    { label: "Partida", value: "08:00 AM" }
  ];

  
  const items = [
    { icon: <FaRegMoneyBillAlt />, title: "Premio en efectivo", text: "Para los primeros puestos en la llegada general (damas y varones)" },
    { icon: <FaMedal />, title: "Medalla Finisher", text: "Para todos los que culminen el recorrido (solo inscritos)" },
    { icon: <MdTimer />, title: "Cronometrado", text: "Tiempo cronometrado elctrónicamente" },
    { icon: <GiTrophyCup />, title: "Premios", text: "Para los primeros puestos de cada categoría (damas y varones)" },
  ];

  /*Solo activar para ver por consola, prueba*/
  console.log({
    nombre,
    apellidos,
    dni,
    correo,
    telefono,
    genero,
    fechaNacimiento,
    grupo,
    otroEquipo,
    talla,
    fotoBienvenida
  });

  return (
     <>
      <HeroVideo
        descripcion="El evento de trail running más esperado del año llega a la costa norte de Perú. Prepárate para vivir una experiencia única entre el mar, la arena y la fuerza del norte. ¡Corre donde el mar y la arena desafían tus límites!"
        video="https://atacaperu.com/wp-content/uploads/2026/05/Trail-del-pescador-Piura.mp4"
        imagen="https://atacaperu.com/wp-content/uploads/2023/04/logo-blanco.png"   
        detalles={detalles_hero}
      />     

      <br />

      <Countdown
        targetDate="2026-06-28T09:00:00"
        titulo="CUENTA REGRESIVA PARA TRAIL DEL PESCADOR 10K"
        descripcion="Prepárate para vivir una experiencia única entre el mar, la arena y la fuerza del norte"
      />

      {/*<Responsib titulo="INSCRIPCIONES" items={items_inscripcion} onButtonClick={abrirModal}/>*/}

      <Modal
        isOpen={modalOpen}
        onClose={() => {
          setModalOpen(false);
          resetFormulario();

        }}
      >
        {
          enviando && (
            <div className="loading-overlay">

              <div className="loading-box">
                <div className="spinner"></div>
                <p>
                  Enviando inscripción...
                </p>
              </div>
            </div>
          )
        }

        <div className="modal-line"></div>
        <h1>
          {
            step===1
            ? "FORMULARIO DE INSCRIPCIÓN"

            :step===2
            ? "TÉRMINOS Y CONDICIONES"
            :"RESUMEN DE INSCRIPCIÓN"
          }
        </h1>
        { step === 1 && (
          <form className="inscripcion-form"
            onSubmit={(e) => {
            e.preventDefault();

            /*Evitar doble clic*/  
            if(loadingStep)return;
            setLoadingStep(true);
            
            /*Verifica que si pone grupo "OTRO", realmente ponga el grupo */
            if (grupo === "otro" && !otroEquipo.trim()) {
              alert("Por favor, escribe el nombre del equipo al que perteneces");              
              setLoadingStep(false);
              return;
            }

            setStep(2);

            setTimeout(() => {
              setLoadingStep(false);
            }, 500);
          }}>

            <input
              type="text"
              placeholder="Nombre"
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
              required
            />
            <input
              type="text"
              placeholder="Apellidos"
              value={apellidos}
              onChange={(e) => setApellidos(e.target.value)}
              required
            />
            <input
              type="text"
              placeholder="DNI"
              value={dni}
              onChange={(e) => setDni(e.target.value)}
              required
            />
            <input
              type="email"
              placeholder="Correo"
              value={correo}
              onChange={(e) => setCorreo(e.target.value)}
              required
            />
            <input
              type="tel"
              placeholder="Teléfono"
              value={telefono}
              onChange={(e) => setTelefono(e.target.value)}
              required
            />

            {/* Género */}
            <div className="radio-group">
              <span className="form-label">
                Género:
              </span>
              <label>
                <input
                  type="radio"
                  name="genero"
                  value="masculino"
                  checked={genero === "masculino"}
                  onChange={(e) => setGenero(e.target.value)}
                  required
                />
                Masculino
              </label>
              <label>
                <input
                  type="radio"
                  name="genero"
                  value="femenino"
                  checked={genero === "femenino"}
                  onChange={(e) => setGenero(e.target.value)}
                  required
                />
                Femenino
              </label>
            </div>

            {/* Fecha */}
            <span className="form-label">
                Fecha de nacimiento:
            </span>
            <input
              type="date"
              value={fechaNacimiento}
              onChange={(e) => setFechaNacimiento(e.target.value)}
              required
            />

            {/* Grupo */}
            <span className="form-label">
                Equipo al que pertenece:
            </span>
            <select
              value={grupo}
              onChange={(e) => setGrupo(e.target.value)}
              required
            >
              <option value="ADES">
                ADES
              </option>
              <option value="ALPHA">
                ALPHA
              </option>
              <option value="LONCCOS RUNNING TEAM">
                LONCCOS RUNNING TEAM
              </option>
              <option value="TAYGETOS">
                TAYGETOS
              </option>
              <option value="RUNNATICOS">
                RUNNATICOS
              </option>
              <option value="ALTURA">
                ALTURA
              </option>
              <option value="CRAZY RUNNING">
                CRAZY RUNNING
              </option>
              <option value="OPTICAS ZAVALA">
                OPTICAS ZAVALA
              </option>
              <option value="PSYCHO RUNNERS">
                PSYCHO RUNNERS
              </option>
              <option value="SAMURAI AQP">
                SAMURAI AQP
              </option>
              <option value="ACADEMIA IPD">
                ACADEMIA IPD
              </option>
              <option value="FUERZA AEREA DEL PERU">
                FUERZA AEREA DEL PERU
              </option>
              <option value="CIMA RUNNERS">
                CIMA RUNNERS
              </option>
              <option value="IMPERIO TRAIL RUNNING">
                IMPERIO TRAIL RUNNING
              </option>
              <option value="TEAM CLARO">
                TEAM CLARO
              </option>
              <option value="NG ATLETIC">
                NG ATLETIC
              </option>
              <option value="LA RESISTENCIA">
                LA RESISTENCIA
              </option>
              <option value="AFABP">
                AFABP
              </option>
              <option value="otro">
                Otro equipo
              </option>
            </select>
            {
              grupo === "otro" && (
                <input
                  type="text"
                  placeholder="Escribe tu equipo"
                  value={otroEquipo}
                  onChange={(e) => setOtroEquipo(e.target.value)}
                />
              )
            }

            {/* Talla */}
            <span className="form-label">
                Talla de polo:
            </span>
            <select 
              value={talla}
              onChange={(e) => setTalla(e.target.value)}
              required>
              <option value="XS">XS</option>
              <option value="S">S</option>
              <option value="M">M</option>
              <option value="L">L</option>
              <option value="XL">XL</option>
            </select>
            <button
              type="submit"
              className="submit-btn"
              disabled={loadingStep}
            >
              {
                loadingStep
                  ? "CARGANDO..."
                  : "Continuar"
              }
            </button>
          </form>
        )}

        {step === 2 && (

          /*Términos, condiciones y foto de bienvenida*/
          <div className="checkbox-step">

            <div className="welcome-photo">
               <span className="form-label">
                Foto de Bienvenida (opcional):
               </span>

            <input
              type="file"
              accept=".jpg,.jpeg,.png,image/jpeg,image/png"
              onChange={(e) => setFotoBienvenida(e.target.files[0])}
            />
            </div>

            <br />

            <label className="checkbox-item">
              <input type="checkbox" 
                checked={bases_generales}
                onChange={(e) => setBasesGenerales(e.target.checked)}
              />
              He leído y acepto las Bases Generales del evento.
            </label>

            <label className="checkbox-item">
              <input type="checkbox" 
                checked={deslinde_responsabilidad}
                onChange={(e) => setDeslindeResponsabilidad(e.target.checked)}
              />
              He leído y acepto el Deslinde de Responsabilidad.
            </label>

            <label className="checkbox-item">
              <input type="checkbox" 
                checked={responsabilidad_sensor}
                onChange={(e) => setResponsabilidadSensor(e.target.checked)}
              />
              He leído y acepto la Responsabilidad del Sensor.
            </label>

            
            <label className="checkbox-item">
              <input type="checkbox" 
                checked={datos_correctos}
                onChange={(e) => setDatosCorrectos(e.target.checked)}
              />
              He leído y acepto que los datos proporcionados sean correctos.
            </label>

            <button 
              disabled={!bases_generales
                || !deslinde_responsabilidad 
                || !responsabilidad_sensor 
                || !datos_correctos}
              className="submit-btn"
              onClick={() => setStep(3)}
            >
              Finalizar inscripción
            </button>

          </div>
        )}

        {(step === 3) && (
          <div className="resume-step">

          <div className="resume-item">
            <strong>Nombre:</strong>
            <span>{nombre}</span>
          </div>

          <div className="resume-item">
            <strong>Apellidos:</strong>
            <span>{apellidos}</span>
          </div>

          <div className="resume-item">
            <strong>DNI:</strong>
            <span>{dni}</span>
          </div>

          <div className="resume-item">
            <strong>Correo:</strong>
            <span>{correo}</span>
          </div>

          <div className="resume-item">
            <strong>Teléfono:</strong>
            <span>{telefono}</span>
          </div>

          <div className="resume-item">
            <strong>Género:</strong>
            <span>{genero}</span>
          </div>

          <div className="resume-item">
            <strong>Fecha nacimiento:</strong>
            <span>{fechaNacimiento}</span>
          </div>

          <div className="resume-item">
            <strong>Equipo:</strong>

            <span>
              {
                grupo === "otro"
                ? otroEquipo
                : grupo
              }
            </span>
          </div>

          <div className="resume-item">
            <strong>Talla:</strong>
            <span>{talla}</span>
          </div>

          <div className="resume-item">
            <strong>Categoría:</strong>
            <span>La categoría será asignada según las bases generales</span>
          </div>

          {
            fotoBienvenida && (

              <div className="resume-photo">

                <strong>
                  Foto de bienvenida:
                </strong>

                <img
                  src={URL.createObjectURL(fotoBienvenida)}
                  alt="Foto bienvenida"
                />

              </div>
            )
          }

          {/**/}
         <CulqiButton
         disabled={/*desactivar mientras está procesando*/
            enviando ||
            !bases_generales ||
            !deslinde_responsabilidad ||
            !responsabilidad_sensor ||
            !datos_correctos}
          title={"TRAIL DEL PESCADOR 10K - VENTA FINAL"} 
          amount={12000}//monto a cobrar
          formData={{
            nombre,
            apellido: apellidos,
            dni,
            email: correo,
            telefono,
            genero,
            fecha_nacimiento: fechaNacimiento,
            grupo: grupo === "otro" ? otroEquipo : grupo,
            talla         
          }}
          onResult={handleFinalResult}
          buttonText={
            enviando
            ? "ENVIANDO..."
            : "PAGAR"
          }
        />
      </div>
      )}
      </Modal>

      <Categories
        titulo="Más fuerte que el cansancio: Trail del Pescador 10K"
        descripcion="Este 28 de junio vive la aventura del Trail del Pescador en Playa Los Órganos 🌊🏃‍♂️.
                     Un recorrido que combina deporte, turismo y energía en un entorno natural único.
                    ¡Únete a la experiencia que te conectará con la costa de Piura y tu espíritu deportivo!"
        imagen="https://atacaperu.com/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-05-at-11.34.23-AM.avif"
        categorias={categorias}
        items={items}
      />
      <ButtonBases url={"https://atacaperu.com/wp-content/uploads/2026/05/BASES-GENERALES-TRAIL-DEL-PESCADOR.pdf"}/>
      <br />
      <br />
      <br />
      <Carrusel2 images={images_carrousel2} titulo="¿Qué incluye tu participación?" />
      <Mapping 
        titulo="Recorrido de la carrera" 
        proximamente={false}
        wikilocUrl="https://es.wikiloc.com/wikiloc/embedv2.do?id=265283033&elevation=off&images=on&maptype=H"
      />
      <Responsib titulo="Responsabilidad y Autorizaciones" items={items_responsib} />
    </>

  );
 
}
